import { createEntityAdapter } from '@ngrx/entity';
import { userRoleListActions } from '../actions';
export const userRoleListAdapter = createEntityAdapter({
    selectId: (item) => item.uuid,
    sortComparer: false
});
export const INIT_STATE = userRoleListAdapter.getInitialState({
    loaded: false,
    loading: false
});
export function reducer(state = INIT_STATE, action) {
    switch (action.type) {
        case userRoleListActions.LOAD_BY_ID: {
            return {
                ...state,
                loading: true
            };
        }
        case userRoleListActions.LOAD_BY_ID_SUCCESS: {
            return {
                ...userRoleListAdapter.upsertOne(action.payload, state),
                loaded: true,
                loading: false
            };
        }
        case userRoleListActions.LOAD_FAILED: {
            return {
                ...state,
                loaded: false,
                loading: false
            };
        }
        case userRoleListActions.UPDATE_SUCCESS: {
            const castAction = action;
            return userRoleListAdapter.updateOne({
                id: castAction.payload.uuid,
                changes: castAction.payload
            }, state);
        }
        case userRoleListActions.CREATE_FAILED:
        case userRoleListActions.DELETE_FAILED:
        case userRoleListActions.UPDATE_FAILED: {
            return { ...state, loading: false };
        }
        default: {
            return state;
        }
    }
}
export const getUserRoleListLoaded = (state) => state.loaded;
export const getUserRoleListLoading = (state) => state.loading;
//# sourceMappingURL=user-role-list.js.map